<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.4 2950" preserveAspectRatio="none">
    <path
      class="cls-1"
      d="M57.6,7.8S6.5,27.9,19.9,72.2s65.3-2.5,77,41.1,39.4,45.2-4.1,75.3-106.4,16.8-70.4,59.5,75.8,30.1,41.7,75.3S-9.4,392.1,20.8,423.9s92-33.5,88.7,20.9-123.9,98-76.2,126.4,92.1,21.8,67.8,67-73.7,28.5-72,72.8,67.8,32.7,67.8,97.1-54.4,6.7-56.1,77.1,50.3,63.6,50.3,63.6,29.3.8,12.5,52.7-107.1,38.6-66.9,118.1c0,0,21.7,31,42.7,28.5s29.3,25.1,29.3,36S76.8,1236,40,1225.9s-35.2,67-1.7,64.5,62,20.9,53.6,48.5-70.3,36-66.1,74.5,73.6,37.7,74.5,87.1-68.7,42.7-71.2,82.9,80.4,35.2,73.7,92.1-74.5,4.2-74.5,81.2,73.7,73.7,77.8,141.5-80.3,77.9-80.3,144,61.9,41,67,72.8,30.1,62,3.3,82.1-68.7-34.4-69.5,25.1,15.1,44.4,31.8,61.1,55.3,38.5,39.4,60.3-71.2,18.4-74.5,56.9S71,2444,71,2444s33.5,3.4,33.5,41.9-83.7,5.9-83.7,66.1,102.9,8.4,79.5,85.4S46.7,2689.6,46.7,2746"
      transform="translate(-3 -0.8)"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: none;
  stroke: rgba(23, 132, 126, 0.7);
  stroke-linecap: round;
  stroke-miterlimit: 10;
  stroke-width: 10px;
}
</style>